import axios from 'axios'
import { useMemo } from 'react'
import { useAppDispatch, useAppSelector } from '../../presentation/hooks/store-hooks'
import { useLocalStorageService } from '../../use-cases/local-storage'
import { useNavigationService } from '../../use-cases/navigation'
import { setTokenState } from '../../application/states/auth'

export const useAxiosInstances = () => {
  // State
  const { auth } = useAppSelector((state) => state)
  // Dispatch
  const dispatch = useAppDispatch()
  // Service
  const { getItem, removeItem } = useLocalStorageService()
  const { navigateTo } = useNavigationService()

  const axiosInstance = useMemo(() => {
    return axios.create({
      baseURL: process.env.REACT_APP_BASE_URL
    })
  }, [])

  const axiosAuthInstance = useMemo(() => {
    const instance = axios.create({
      baseURL: process.env.REACT_APP_BASE_URL,
      timeout: Number(process.env.AXIOS_TIMEOUT ?? 0)
    })

    // Interceptor de request: sempre busca o token atualizado do localStorage
    instance.interceptors.request.use((config) => {
      const tokenStorage = getItem({
        key: 'ACCESS_TOKEN'
      })
      
      if (tokenStorage) {
        config.headers.Authorization = `Bearer ${tokenStorage}`
      } else if (auth.token && auth.token !== '' && auth.token !== 'not_valid') {
        config.headers.Authorization = `Bearer ${auth.token}`
      }
      
      return config
    }, (error) => {
      return Promise.reject(error)
    })

    instance.interceptors.response.use((response) => {
      return response
    }, (error) => {
      if (error?.response?.status === 401) {
        const tokenStorage = getItem({
          key: 'ACCESS_TOKEN'
        })

        if (tokenStorage || (auth.token && auth.token !== 'not_valid')) {
          dispatch(setTokenState(''))
          removeItem({
            key: 'ACCESS_TOKEN'
          })
          removeItem({
            key: 'LOGIN_TIMESTAMP'
          })
        }
        window.localStorage.clear()
        window.sessionStorage.clear()

        const resData = error.response?.data || {}
        const msg = resData.message || resData.error || resData.Mensagem || resData.mensagem || ""
        const isIpBlock = Boolean(msg && typeof msg === 'string' && msg.toLowerCase().includes("ip"))

        let loginUrl = String(process.env.REACT_APP_VELES_APP_URL_LOGIN)
        if (!loginUrl.includes('/authentication/login')) {
          loginUrl = loginUrl.replace('/auth/login', '/authentication/login')
        }

        if (isIpBlock && msg) {
          window.location.href = `${loginUrl}?message=${encodeURIComponent(msg)}`
        } else if (window.location.pathname !== '/auth/login') {
          const appBaseUrl = loginUrl.replace('/authentication/login', '').replace('/auth/login', '')
          window.location.href = `${appBaseUrl}`
        }
      }
      return Promise.reject(error)
    }
    )
    return instance
  }, [removeItem, getItem, dispatch])

  return {
    axiosInstance,
    axiosAuthInstance
  }
}